/**
 * DRG Status Enum. Good as of 03/01/2017
 */

const data = [
  { key: "NOT_READY", value: "Not Ready" },
  { key: "UNDER_EVALUATION", value: "Under Evaluation" },
  { key: "READY", value: "Ready" },
  { key: "SENT", value: "Sent" },
  { key: "ACCEPTED", value: "Accepted" },
  { key: "REJECTED", value: "Rejected" },
];

export { data as default };
